import { lazy, StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import { isLocal } from './utils/env.ts'
import { worker } from './mocks/browser.ts'

const App = lazy(() => import('./App.tsx'))

if (isLocal) {
  worker.start({ onUnhandledRequest: 'bypass' })
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
)
